export default __webpack_public_path__ + "static/media/photo--sm--misc-18.f28098b8.jpg";